export default __webpack_public_path__ + "static/slika6-7aa8d240b73ee36566aee4da2f4e700d.jpg";